import React from 'react';
import { Link } from 'react-router-dom';
import useTranslation from '../hooks/useTranslation';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  // KB에스크로 인증마크 팝업 함수
  const onPopKBAuthMark = () => {
    window.open('', 'KB_AUTHMARK', 'height=604, width=648, status=yes, toolbar=no, menubar=no, location=no');
    const form = document.forms.namedItem('KB_AUTHMARK_FORM') as HTMLFormElement;
    if (form) {
      form.action = 'https://okbfex.kbstar.com/quics';
      form.target = 'KB_AUTHMARK';
      form.submit();
    }
  };
  
  return (
    <footer className="py-6 px-4 border-t border-gray-200 mt-4 mb-16">
      <div className="max-w-screen-xl mx-auto text-left">
        <div className="flex space-x-6">
          <Link 
            to="/terms" 
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            {t('Terms of Use')}
          </Link>
          <Link 
            to="/privacy" 
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            {t('Privacy Policy')}
          </Link>
        </div>
        
        {/* Company Information */}
        <div className="mt-4 space-y-1 text-xs text-gray-400">
          <div className="flex flex-col space-y-1">
            <p>Company: ORDER MADE EASY</p>
            <p>Chief Privacy Officer: Dongjin Lee</p>
            <p>Address: 24-11, Baekjegobun-ro 40-gil, Songpa-gu, Seoul</p>
            <p>Email: koreaorder.official@gmail.com</p>
            <p>Business Registration No: 262-11-02956</p>
            <p>Online Sales Registration Number: 2025-서울송파-2267</p>
          </div>
        </div>
        
        {/* KB에스크로 이체 인증마크 */}
        <div className="mt-4">
          <form name="KB_AUTHMARK_FORM" method="get" style={{ display: 'none' }}>
            <input type="hidden" name="page" value="C021590"/>
            <input type="hidden" name="cc" value="b034066:b035526"/>
            <input type="hidden" name="mHValue" value="1ad0add02643478ca99ae65e71e9b9a1"/>
          </form>
          <button 
            onClick={onPopKBAuthMark}
            className="inline-block bg-transparent border-none p-0 cursor-pointer"
            type="button"
          >
            <img 
              src="http://img1.kbstar.com/img/escrow/escrowcmark.gif" 
              alt="KB에스크로 이체 인증마크"
              style={{ border: 0 }}
              className="w-10 h-auto"
            />
          </button>
        </div>
        
        <div className="border-t border-gray-200 pt-3 mt-4">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} KOREA ORDER. {t('All rights reserved')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 